<template>
  <div class="col-xs-12">
    <div class="box-body form-center">
      <button class="btn btn-success" @click="addNewCoupon()">新增贈送優惠券</button>
      <table aria-describedby="example1_info" role="grid" id="example2" class="table table-bordered table-striped dataTable">
        <thead>
        <tr role="row">
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
          <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">優惠券</th>
          <th></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr class="even" role="row" v-for="(coupon, index) in giveCoupons.coupon_set_list">
          <!-- cloumn 0 -->
          <td class="sorting_1">{{index + 1}}</td>
          <!-- column 1-->
          <td>
            {{coupon.coupon_info.name}}
          </td>
          <td>
            <button class="btn btn-default" @click="changeCur(coupon, index)"><i class="fa fa-pencil"></i></button>
          </td>
          <td>
            <button class="btn btn-danger" data-target="#delCouponModal" data-toggle="modal"  @click="curIndex = index"><i class="fa fa-trash" aria-hidden="true"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-xs-12" v-if="curCoupon.coupon_info">
      <hr class="box-body form-left">
      <div class="box-body form-center">
        <h4>編輯{{curCoupon.coupon_info.name}}</h4>
      </div>
      <div class="box-body form-left">
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券名稱(前台)</span>
            <input class="form-control" placeholder="名稱" type="text" v-model="curCoupon.coupon_info.name" maxlength="45">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券名稱(後台)</span>
            <input class="form-control" placeholder="名稱" type="text" v-model="curCoupon.coupon_info.set_name" maxlength="45">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券說明(前台)</span>
            <textarea class="form-control" placeholder="優惠券說明" v-model="curCoupon.coupon_info.description" maxlength="1024"></textarea>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券說明(後台)</span>
            <textarea class="form-control" placeholder="優惠券說明" v-model="curCoupon.coupon_info.set_description" maxlength="1024"></textarea>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券備註(前台)</span>
            <textarea class="form-control" placeholder="優惠券備註" v-model="curCoupon.coupon_info.remark" maxlength="100"></textarea>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券折扣金額</span>
            <input class="form-control" placeholder="優惠券折扣金額" type="text" v-model="curCoupon.coupon_info.discount_value">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>一次發送張數</span>
            <input class="form-control" placeholder="張數" type="text" v-model="curCoupon.amount_unit" maxlength="2">
          </div>
          <br />
        </div>
      </div>
      <div class="box-body form-right">
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券稅制</span>
            <multiselect
                    v-model="curCoupon.coupon_info.price_type"
                    :options="priceType"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="優惠券稅制"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
            >
            </multiselect>
          </div>
          <br />
        </div>
        <div v-show="getRoleType !== 10">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>優惠券類型</span>
            <multiselect
                    v-model="curCoupon.usage_store_config.usage_store_type"
                    :options="couponType"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="優惠券類型"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
                    @select="selectUSType"
                    @input="changeUSType"
            >
            </multiselect>
          </div>
          <br />
        </div>
        <div v-show="getRoleType !== 10">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>適用門市方式</span>
            <multiselect
                    v-model="curCoupon.usage_store_config.usage_method"
                    :options="usageMethod"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="優惠券稅制"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
            >
            </multiselect>
          </div>
          <br />
        </div>
        <div v-show="curCoupon.usage_store_config.usage_method.value !== 'order_store' && getRoleType !== 10">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>適用對象</span>
            <multiselect
                    v-model="curCoupon.usage_store_config.usage_store_value"
                    :options="couponValue"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="優惠券稅制"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
                    @select="selectUSValue"
            >
            </multiselect>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>有效期間設定</span>
            <multiselect
                    v-model="curCoupon.time_config.time_type"
                    :options="timeType"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="優惠券稅制"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
            >
            </multiselect>
          </div>
          <br />
        </div>
        <div v-if="curCoupon.time_config.time_type.value === 'all_fixed'">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>開始時間</span>
            <date-time-picker :date="curCoupon.time_config.time.start" :option="timeoption" :limit="startLimit"></date-time-picker>
            <!--<input class="form-control" placeholder="YYYY-MM-DD hh:mm:ss" type="text" v-model="curCoupon.time_config.start_time" maxlength="19">-->
          </div>
          <br />
        </div>
        <div  v-if="curCoupon.time_config.time_type.value === 'day_day' ||curCoupon.time_config.time_type.value === 'day_fixed' ">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>拿到優惠券後幾天開始</span>
            <input class="form-control" placeholder="天數" type="text" v-model="curCoupon.time_config.use_start_day" maxlength="3">
          </div>
          <br />
        </div>
        <div  v-if="curCoupon.time_config.time_type.value === 'all_fixed' ||curCoupon.time_config.time_type.value === 'day_fixed' ">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>結束時間</span>
            <date-time-picker :date="curCoupon.time_config.time.end" :option="timeoption" :limit="endLimit"></date-time-picker>
            <!--<input class="form-control" placeholder="YYYY-MM-DD hh:mm:ss" type="text" v-model="curCoupon.time_config.end_time" maxlength="19">-->
          </div>
          <br />
        </div>
        <div  v-if="curCoupon.time_config.time_type.value === 'day_day'">
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>開始後幾天結束</span>
            <input class="form-control" placeholder="天數" type="text" v-model="curCoupon.time_config.use_tolerance_day" maxlength="3">
          </div>
          <br />
        </div>
      </div>
      <div class="box-body form-center" v-show="curCoupon.usage_store_config.usage_method.value === 'manual' && curCoupon.usage_store_config.usage_store_type.value !== 3 && getRoleType !== 10">
        <h5><span class="text-red">＊ </span>優惠券可用店家</h5>
        <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet" ref="couponStoresMuti"></muti-select-two>
      </div>
    </div>
    <coupon-modal :coupon="curCoupon"></coupon-modal>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import couponModal from './CouponModal.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: {
    brandList: Array,
    storeList: Array,
    giveCoupons: Object,
    info: Object,
    activity: Object
  },
  components: {
    'date-time-picker': datetimePicker,
    'coupon-modal': couponModal
  },
  computed: {
    ...mapGetters(['getRoleType']),
    couponValue () {
      let couponType = ''
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type
        if (couponType.value === 2) {
          // 品牌
          return this.brandList
        } else if (couponType.value === 3) {
          // 店家
          return this.storeList
        }
      }
      return []
    },
    usageMethod () {
      let couponType = ''
      if (this.curCoupon.coupon_info) {
        couponType = this.curCoupon.usage_store_config.usage_store_type
        if (couponType.value === 2) {
          // 品牌
          return [{label: '設定優惠券適用門市', value: 'manual'}]
        } else if (couponType.value === 3) {
          // 店家
          return [{label: '設定優惠券適用門市', value: 'manual'}, {label: '限下訂門市使用', value: 'order_store'}]
        }
      }
      return []
    }
  },
  data () {
    return {
      setInfoTimes: 0,
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      reNew: 0,
      reSet: 0,
      timeType: [
        {label: '限定時段', value: 'all_fixed'},
        {label: '獲取後～某時段結束', value: 'day_fixed'},
        {label: '獲取後～獲取幾日後結束', value: 'day_day'}
      ],
      couponType: [
        // {label: '平台', value: 1},
        {label: '品牌', value: 2},
        {label: '門市', value: 3}
      ],
      priceType: [
        {label: '免稅', value: 1},
        {label: '未稅', value: 2},
        {label: '含稅', value: 3}
      ],
      newCouponType: {label: '商品數量', value: 'SC00001'},
      delOption: {
        id: 'delCouponModal',
        title: '刪除贈送優惠券',
        body: '刪除此優惠券，設定的內容將被刪除',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delCoupon'
          }
        ]
      },
      curIndex: 0,
      curCoupon: {},
      ruleCodeOptions: [
        {label: '商品數量', value: 'SC00001'},
        {label: '指定商品數量', value: 'SC00002'},
        {label: '商品金額', value: 'SC00003'}
      ],
      dCouponType: '',
      startLimit: [
        {
          type: 'fromto',
          from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      oldIndex: ''
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delCoupon') {
        this.delCoupon()
      }
    },
    addNewCoupon () {
      const num = this.giveCoupons.coupon_set_list.length + 1
      const obj = {
        coupon_info: {
          set_name: '優惠券' + num,
          set_description: '',
          name: '優惠券' + num,
          description: '',
          remark: '',
          discount_type: 1,
          discount_value: '',
          price_type: {label: '含稅', value: 3}
        },
        usage_store_config: {
          usage_store_type: {label: '品牌', value: 2}, // 會被roleType限制
          usage_store_value: null,
          usage_method: {label: '設定優惠券適用門市', value: 'manual'},
          manual_store_ids: [] // usage_method === manual 需要
        },
        time_config: {
          time_type: {label: '限定時段', value: 'all_fixed'},
          start_time: '',
          end_time: '',
          use_start_day: '',
          use_tolerance_day: '',
          time: {
            start: { time: '' },
            end: { time: '' }
          }
        },
        is_group_usage: 1,
        amount_unit: 1
      }
      // 如果擁有者或門市管理者，只能新增門市優惠券
      if (this.dCouponType && this.dCouponType === 2) obj.usage_store_config.usage_store_type = this.brandList[0]
      if (this.dCouponType && this.dCouponType === 3) obj.usage_store_config.usage_store_type = {label: '門市', value: 3}
      if (this.getRoleType === 10) {
        obj.usage_store_config.usage_store_value = this.storeList[0]
        obj.usage_store_config.usage_store_type = {label: '門市', value: 3}
        obj.usage_store_config.usage_method = {label: '限下訂門市使用', value: 'order_store'}
      }
      this.giveCoupons.coupon_set_list.push(obj)
      // 馬上編輯此優惠券
      this.changeCur(obj)
    },
    changeCur (coupon, index) {
      if (this.oldIndex !== index) {
        this.curCoupon = coupon
        this.addStoresSetting.choose = this.curCoupon.usage_store_config.manual_store_ids
        if (this.$refs.couponStoresMuti) this.$refs.couponStoresMuti.init()
        this.oldIndex = index
      }
    },
    selectUSValue (obj) {
      if (this.curCoupon.usage_store_config.usage_store_type.value === 3 && this.curCoupon.usage_store_config.usage_method.value === 'manual') {
        this.curCoupon.usage_store_config.manual_store_ids = [obj.value]
      }
    },
    selectUSType () {
      this.curCoupon.usage_store_config.usage_store_value = null
    },
    changeUSType () {
      if (this.curCoupon.usage_store_config.usage_store_type.value === 2) this.curCoupon.usage_store_config.usage_method = {label: '設定優惠券適用門市', value: 'manual'}
    },
    delCoupon () {
      this.giveCoupons.coupon_set_list.splice(this.curIndex, 1)
    },
    setInfo () {
      this.setInfoTimes++
      const self = this
      const iList = this.info.give_coupons[0].coupon_set_list
      iList.forEach(function (coupon) {
        // console.log(self.usageMethod, coupon.usage_store_config.usage_store_method)
        // console.log(self.couponValue, coupon.usage_store_config.usage_store_value)
        let obj = {
          coupon_info: {
            set_name: coupon.set_name,
            set_description: coupon.set_description,
            name: coupon.name,
            description: coupon.description,
            remark: coupon.remark,
            discount_type: 1,
            discount_value: coupon.discount_value,
            price_type: self.priceType.find(function (pt) { return pt.value === coupon.price_type })
          },
          usage_store_config: {
            usage_store_type: self.couponType.find(function (ct) { return ct.value === coupon.usage_store_config.usage_store_type }),
            usage_store_value: null,
            usage_method: '',
            manual_store_ids: [] // usage_method === manual 需要
          },
          time_config: {
            time_type: self.timeType.find(function (tt) { return tt.value === coupon.time_config.time_type }),
            start_time: '',
            end_time: '',
            use_start_day: '',
            use_tolerance_day: '',
            time: {
              start: { time: '' },
              end: { time: '' }
            }
          },
          is_group_usage: 1,
          amount_unit: coupon.amount_unit
        }
        const cusConfig = coupon.usage_store_config
        const oCusConfig = obj.usage_store_config
        const ctConfig = coupon.time_config
        const oTConfig = obj.time_config
        // usage_method
        let usageMethod = []
        if (cusConfig.usage_store_type === 2) {
          // 品牌
          usageMethod = [{label: '設定優惠券適用門市', value: 'manual'}]
        } else if (cusConfig.usage_store_type === 3) {
          // 店家
          usageMethod = [{label: '設定優惠券適用門市', value: 'manual'}, {label: '限下訂門市使用', value: 'order_store'}]
        }
        oCusConfig.usage_method = usageMethod.find(function (um) { return um.value === cusConfig.usage_store_method })
        // usage_store_value
        if (cusConfig.usage_store_value) {
          let couponValue = []
          if (cusConfig.usage_store_type === 2) {
            // 品牌
            couponValue = self.brandList
          } else if (cusConfig.usage_store_type === 3) {
            // 店家
            couponValue = self.storeList
          }
          // console.log(self.storeList)
          // console.log('data1', couponValue)
          oCusConfig.usage_store_value = couponValue.find(function (cv) { return cv.value === cusConfig.usage_store_value })
          // console.log('data2', oCusConfig.usage_store_value)
        }
        // manual_stores
        // usage_store_config.manual_store_ids
        if (cusConfig.manual_stores) {
          cusConfig.manual_stores.forEach(function (brand) {
            brand.store_list.forEach(function (store) {
              oCusConfig.manual_store_ids.push(store.store_id)
            })
          })
        }
        // time_config
        if (ctConfig.valid_start_time) {
          oTConfig.start_time = ctConfig.valid_start_time
          oTConfig.time.start.time = ctConfig.valid_start_time
        }
        if (ctConfig.valid_end_time) {
          oTConfig.end_time = ctConfig.valid_end_time
          oTConfig.time.end.time = ctConfig.valid_end_time
        }
        if (ctConfig.use_start_day || ctConfig.use_start_day === 0) oTConfig.use_start_day = ctConfig.use_start_day
        if (ctConfig.use_tolerance_day || ctConfig.use_tolerance_day === 0) oTConfig.use_tolerance_day = ctConfig.use_tolerance_day
        // console.log(obj)
        // console.log(self.giveCoupons)
        self.giveCoupons.coupon_set_list.push(obj)
      })
    }
  },
  watch: {
    'activity.owner_type.value' () {
      this.dCouponType = this.activity.owner_type.value
      if (this.dCouponType === 3) {
        this.giveCoupons.coupon_set_list.forEach(function (coupon) {
          coupon.usage_store_config.usage_store_type = {label: '門市', value: 3}
          coupon.usage_store_config.usage_store_value = null
        })
      }
    },
    'curCoupon.coupon_info.name' () {
      if (this.$route.name.indexOf('cr') > -1) this.curCoupon.coupon_info.set_name = this.curCoupon.coupon_info.name
    },
    'curCoupon.coupon_info.description' () {
      if (this.$route.name.indexOf('cr') > -1) this.curCoupon.coupon_info.set_description = this.curCoupon.coupon_info.description
    },
    'curCoupon.time_config.time.start.time' () {
      this.curCoupon.time_config.start_time = this.curCoupon.time_config.time.start.time
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.curCoupon.time_config.time.start.time).subtract(1, 'days')
        }
      ]
    },
    'curCoupon.time_config.time.end.time' () {
      this.curCoupon.time_config.end_time = this.curCoupon.time_config.time.end.time
    },
    storeList () {
      this.addStoresSetting.options = this.storeList
      this.addStoresSetting.choose = []
      if (this.$route.name === 'upActivity' && !this.setInfoTimes && this.storeList.length) {
        this.setInfo()
      }
    },
    'addStoresSetting.choose' () {
      if (this.curCoupon.usage_store_config) {
        this.curCoupon.usage_store_config.manual_store_ids = this.addStoresSetting.choose
      }
    },
    setInfoTimes () {
      // this.setInfo()
    },
    curCoupon () {
      const self = this
      setTimeout(function () {
        if (self.$refs.couponStoresMuti) {
          self.$refs.couponStoresMuti.init()
        }
      }, 1000)
    }
  }
}
</script>
<style lang="sass" scoped>
  .un-active
    opacity: .3
</style>



// WEBPACK FOOTER //
// CouponList.vue?edf73784